import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
var useAssessmentsReportContext = function () {
    var _a = useParams(), districtId = _a.districtId, schoolId = _a.schoolId;
    var context = useMemo(function () {
        var value;
        if (districtId) {
            value = 'district';
        }
        else if (schoolId) {
            value = 'school';
        }
        if (!value)
            throw new Error('No assessments context found');
        return [
            value,
            {
                districtId: districtId,
                schoolId: schoolId,
            },
        ];
    }, [districtId, schoolId]);
    return context;
};
export { useAssessmentsReportContext };
